import { render } from "./TestCommercialPotential.vue?vue&type=template&id=7530585c&scoped=true"
import script from "./TestCommercialPotential.vue?vue&type=script&lang=js"
export * from "./TestCommercialPotential.vue?vue&type=script&lang=js"

import "./TestCommercialPotential.vue?vue&type=style&index=0&id=7530585c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7530585c"]])

export default __exports__